/* Paws Meows — lm-global.js · globale Funktionen ohne theme.liquid-Edit (geladen über sections/lm-global.liquid)
   1) Header-Icon-Labels  2) Back-to-top  3) Cart-Drawer/Cart-Page: Versandkosten-Balken + Preview-Thumbnails
   Preview-Thumbnails: Line-Item-Property "_preview_url" (gesetzt vom Konfigurator) ersetzt das Produktbild im Warenkorb. */
(function () {
  'use strict';
  var root = document.getElementById('lm-global');
  if (!root) return;
  var cfg = {
    threshold: Number(root.dataset.freeShipping || 0) * 100,
    labels: { search: root.dataset.labelSearch, account: root.dataset.labelAccount, cart: root.dataset.labelCart },
    iconLabels: root.dataset.iconLabels === 'true',
    toTop: root.dataset.backToTop === 'true',
    previews: root.dataset.cartPreviews === 'true',
    msgAway: root.dataset.msgAway || "You're {amount} away from free US shipping",
    msgDone: root.dataset.msgDone || 'Free US shipping unlocked',
    cartTrust: root.dataset.cartTrust || '',
    cartRating: root.dataset.cartRating || '',
    cartRatingText: root.dataset.cartRatingText || '',
    stickyCta: root.dataset.stickyCta === 'true',
    stickyLabel: root.dataset.stickyLabel || '',
    stickySub: root.dataset.stickySub || '',
    stickyUrl: root.dataset.stickyUrl || '',
    xsell: (root.dataset.xsell || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean),
    xsellTitle: root.dataset.xsellTitle || "Add {name}'s {product}",
    xsellSub: root.dataset.xsellSub || 'Same portrait, no new upload',
    /* Runde 25: Rabatt auf Zusatzprodukte. 0 = aus, und dann zeigt die Zeile auch keinen
       durchgestrichenen Preis. Der Wert darf NUR gesetzt werden, wenn im Shopify-Admin ein
       echter automatischer Rabatt mit demselben Prozentsatz laeuft - sonst steht im
       Warenkorb ein Preis, den der Checkout nicht einloest. */
    xsellDiscount: Math.max(0, Math.min(70, Number(root.dataset.xsellDiscount || 0))),
    xsellDiscountNote: root.dataset.xsellDiscountNote || '',
    xsellDiscountUsed: root.dataset.xsellDiscountUsed || ''
  };

  /* ---------- 1) Header-Icons vereinheitlichen ----------
     Dawn liefert drei Icons in drei Sprachen: Lupe auf 18x19, Konto auf 18x19, Tasche auf 40x40,
     alle als Flaechen (fill). Nebeneinander wirken sie unterschiedlich schwer und unterschiedlich
     gross - egal wie man die Boxen skaliert. Deshalb werden sie hier durch drei eigene Strichicons
     auf demselben 24er-Raster ersetzt (gleiche Strichstaerke wie snippets/lm-icon.liquid).
     Das Original bleibt im DOM, nur versteckt: Dawn tauscht die Klassen icon-cart-empty/icon-cart
     beim Aktualisieren des Warenkorbs, das soll weiter funktionieren. */
  var HEADER_PATHS = {
    search: '<circle cx="10.8" cy="10.8" r="6.4"/><path d="m15.6 15.6 4.4 4.4"/>',
    account: '<circle cx="12" cy="8.2" r="3.5"/><path d="M5 20c.5-3.6 3.4-5.7 7-5.7s6.5 2.1 7 5.7"/>',
    cart: '<path d="M6.4 8.4h11.2l1 10.4a1.5 1.5 0 0 1-1.5 1.6H6.9a1.5 1.5 0 0 1-1.5-1.6l1-10.4Z"/><path d="M9.3 10.6V7.4a2.7 2.7 0 0 1 5.4 0v3.2"/>'
  };
  function lmSvg(key) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'lm-hicon lm-hicon--' + key);
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.7');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.innerHTML = HEADER_PATHS[key];
    return svg;
  }
  function paintHeaderIcons() {
    [['.header__icon--search > span > .svg-wrapper:not(.header__icon-close)', 'search'],
     ['shopify-account > [slot]', 'account'],
     ['#cart-icon-bubble > .svg-wrapper', 'cart']].forEach(function (p) {
      document.querySelectorAll(p[0]).forEach(function (wrap) {
        if (wrap.querySelector('.lm-hicon')) return;
        var orig = wrap.querySelector('svg:not(.lm-hicon)');
        if (orig) orig.classList.add('lm-hicon-orig');
        wrap.appendChild(lmSvg(p[1]));
      });
    });
  }

  /* ---------- 1b) Icon-Labels ---------- */
  function iconLabels() {
    if (!cfg.iconLabels) return;
    [['search', '.header__icon--search'], ['account', '.header__icon--account'], ['cart', '.header__icon--cart']].forEach(function (p) {
      document.querySelectorAll(p[1]).forEach(function (el) {
        if (!cfg.labels[p[0]]) return;
        var host = el;
        if (el.tagName.indexOf('-') > -1) { /* Custom Element (z. B. <shopify-account>) mit Shadow DOM: Label in Wrapper daneben */
          if (el.parentElement && el.parentElement.classList.contains('lm-icon-wrap')) return;
          var w = document.createElement('span');
          w.className = 'lm-icon-wrap';
          el.parentNode.insertBefore(w, el);
          w.appendChild(el);
          host = w;
        }
        if (host.querySelector(':scope > .lm-icon-label')) return;
        var s = document.createElement('span');
        s.className = 'lm-icon-label';
        s.textContent = cfg.labels[p[0]];
        host.appendChild(s);
      });
    });
  }

  /* ---------- 2) Back to top ---------- */
  function backToTop() {
    if (!cfg.toTop) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'lm-totop'; btn.setAttribute('aria-label', root.dataset.labelTop || 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5m0 0-6 6m6-6 6 6"/></svg>';
    document.body.appendChild(btn);
    var ticking = false;
    function check() { btn.classList.toggle('is-visible', window.scrollY > 700); ticking = false; }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    check();
  }

  /* ---------- 2b) Mobile Sticky-CTA (Startseite, Kollektionen, Seiten) ----------
     Auf dem Handy liegt der Hero-CTA nach dem ersten Wisch hinter dem Nutzer, und die naechste
     Handlungsaufforderung kommt erst Sektionen spaeter. Diese Leiste haelt den einen Weg zum Ziel
     (Foto hochladen, Preview sehen) am unteren Rand fest - erscheint nach 480 px Scroll, verschwindet,
     sobald der Footer sichtbar wird. Nicht auf Produkt-, Warenkorb- und Kontoseiten: dort hat die
     Seite bereits ihre eigene Kaufleiste bzw. keinen Portrait-Kontext. Nur unter 990 px (CSS). */
  function stickyCta() {
    if (!cfg.stickyCta || !cfg.stickyLabel || !cfg.stickyUrl) return;
    /* Dawn setzt keine template-Klassen auf <body>; erkannt wird ueber Pfad und Konfigurator-Section. */
    var path = location.pathname;
    if (document.querySelector('[data-lm-configurator]') || /^\/(cart|account|search|checkouts?|password)(\/|$)/.test(path) || path.indexOf('/products/') > -1) return;
    if (document.querySelector('.lm-stickycta')) return;
    var a = document.createElement('a');
    a.className = 'lm-stickycta'; a.href = cfg.stickyUrl;
    a.innerHTML = '<span class="lm-stickycta__text"><span class="lm-stickycta__main"></span><span class="lm-stickycta__sub"></span></span>' +
      '<span class="lm-stickycta__arrow" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12h15"/><path d="m13.4 5.8 6.1 6.2-6.1 6.2"/></svg></span>';
    a.querySelector('.lm-stickycta__main').textContent = cfg.stickyLabel;
    var sub = a.querySelector('.lm-stickycta__sub');
    if (cfg.stickySub) sub.textContent = cfg.stickySub; else sub.remove();
    document.body.appendChild(a);
    var footer = document.querySelector('.footer, footer');
    var footerIn = false;
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { footerIn = e.isIntersecting; }); check(); }, { threshold: 0 }).observe(footer);
    }
    var ticking = false;
    function check() {
      var on = window.scrollY > 480 && !footerIn;
      a.classList.toggle('is-visible', on);
      document.body.classList.toggle('lm-has-stickycta', on);
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    a.addEventListener('click', function () {
      if (window.dataLayer) window.dataLayer.push({ event: 'StickyCtaClick', page: location.pathname });
    });
    check();
  }

  /* ---------- 2c) Bild-Mega-Menue ----------
     Dawns Mega-Menue ist eine nackte Versalienliste ueber die ganze Breite. Mit dem Kollektionsbild
     je Link (JSON aus lm-global.liquid) wird daraus ein Raster aus Bildkarten - man erkennt Regal,
     Studio, Becher oder Hoodie, bevor man liest. Links ohne Bild bleiben Text. */
  function megaMenu() {
    var node = document.getElementById('lm-menu-images');
    if (!node) return;
    var map; try { map = JSON.parse(node.textContent); } catch (e) { return; }
    document.querySelectorAll('.mega-menu__list').forEach(function (ul) {
      if (ul.classList.contains('lm-mega')) return;
      var links = ul.querySelectorAll('a.mega-menu__link');
      var hits = 0;
      links.forEach(function (a) {
        var href = (a.getAttribute('href') || '').split('?')[0];
        var src = map[href];
        if (!src) return;
        hits++;
        a.classList.add('lm-mega__link');
        var wrap = document.createElement('span');
        wrap.className = 'lm-mega__img';
        var img = document.createElement('img');
        img.src = src; img.alt = ''; img.loading = 'lazy'; img.width = 360; img.height = 360;
        wrap.appendChild(img);
        var label = document.createElement('span');
        label.className = 'lm-mega__label';
        label.textContent = a.textContent.trim();
        a.textContent = '';
        a.appendChild(wrap); a.appendChild(label);
      });
      if (hits) ul.classList.add('lm-mega');
    });
    /* Die Bilder sind lazy (17 Bilder gehoeren nicht in den Seitenstart). Beim ersten Beruehren des
       Menuepunkts werden sie vorgeladen, damit das Menue mit Bildern aufgeht statt mit grauen Kacheln. */
    document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
      function warm() {
        d.querySelectorAll('.lm-mega__img img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        d.removeEventListener('pointerenter', warm); d.removeEventListener('focusin', warm);
      }
      d.addEventListener('pointerenter', warm); d.addEventListener('focusin', warm);
    });
  }

  /* ---------- 3) Cart enhancements ---------- */
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  function renderShipbar(container, cart) {
    if (!cfg.threshold || !container) return;
    var bar = container.querySelector('.lm-shipbar');
    if (cart.item_count === 0) { if (bar) bar.remove(); return; }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'lm-shipbar';
      bar.setAttribute('role', 'status');
      bar.innerHTML = '<div class="lm-shipbar__text"></div><div class="lm-shipbar__track"><div class="lm-shipbar__fill"></div></div>';
      var anchor = container.querySelector('.drawer__header') || container.querySelector('.cart__items') || container.firstElementChild;
      if (anchor && anchor.parentNode) anchor.insertAdjacentElement(anchor.classList.contains('drawer__header') ? 'afterend' : 'beforebegin', bar);
      else container.prepend(bar);
    }
    var total = cart.items_subtotal_price;
    var left = cfg.threshold - total;
    var done = left <= 0;
    bar.classList.toggle('lm-shipbar--done', done);
    bar.querySelector('.lm-shipbar__text').textContent = done ? cfg.msgDone : cfg.msgAway.replace('{amount}', money(left));
    bar.querySelector('.lm-shipbar__fill').style.width = Math.min(100, Math.round(total / cfg.threshold * 100)) + '%';
  }

  /* Kleines Icon-Set fuer JS-gerenderte Trust-Zeilen. Gleiche Sprache wie snippets/lm-icon.liquid:
     24er-Raster, currentColor, keine Emoji. */
  var TRUST_PATHS = {
    check: '<path d="m4.8 12.6 4.6 4.6L19.2 7.4"/>',
    shield: '<path d="M12 3 5 5.9v5.3c0 4.3 2.9 8.2 7 9.3 4.1-1.1 7-5 7-9.3V5.9L12 3Z"/><path d="m9 12 2.2 2.2L15.4 10"/>',
    lock: '<rect x="4.6" y="10.4" width="14.8" height="9.4" rx="2.2"/><path d="M8.2 10.4V7.8a3.8 3.8 0 0 1 7.6 0v2.6"/>',
    flag: '<path d="M4 21V4"/><path d="M4 5.2h15.4v8.6H4"/><path d="M4 8.1h15.4M4 11h15.4"/><path d="M4 5.2h6.8v5.8H4"/>',
    truck: '<path d="M2.6 7.2h10.1v9.1H2.6z"/><path d="M12.7 10.5h3.6l3.1 3.1v2.7h-6.7z"/><circle cx="7" cy="18.2" r="1.7"/><circle cx="16.4" cy="18.2" r="1.7"/>'
  };
  function svgFor(label) {
    var t = String(label).toLowerCase(), k = 'check';
    if (t.indexOf('guarant') > -1 || t.indexOf('likeness') > -1) k = 'shield';
    else if (t.indexOf('secure') > -1 || t.indexOf('checkout') > -1) k = 'lock';
    else if (t.indexOf('usa') > -1) k = 'flag';
    else if (t.indexOf('truck') > -1 || t.indexOf('hands') > -1 || t.indexOf('deliver') > -1) k = 'truck';
    return '<svg class="lm-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" '
      + 'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'
      + TRUST_PATHS[k] + '</svg>';
  }

  /* Runde 27e: vierte Zusage in der Trust-Zeile - Sterne plus Markenbewertung.
     Dima: "dann wirkt es besser dass 4 sind anstatt 3" - stimmt, drei Punkte brechen auf
     dem Telefon in 1+2, vier in 2+2. Die Zahl ist eine Aussage ueber den ganzen Shop und
     geht bewusst NICHT in aggregateRating; dort stuende sonst eine Produktbewertung, die es
     fuer das einzelne Produkt nicht gibt.
     Die Sterne nutzen dieselben Klassen wie auf der Produktseite - zwei Reihen uebereinander,
     die obere auf den Prozentwert beschnitten. 4,7 sieht damit aus wie vier ganze plus ein
     Dreiviertel und nicht wie fuenf volle. */
  function escHtml(v) {
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  var STAR_PATH = 'M10 1.6l2.47 5.28 5.53.72-4.06 3.9 1.03 5.68L10 14.4l-4.97 2.78 1.03-5.68L2 7.6l5.53-.72L10 1.6z';
  function starRow(cls) {
    var out = '';
    for (var i = 0; i < 5; i++) {
      out += '<svg width="11" height="11" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false"><path d="' + STAR_PATH + '"/></svg>';
    }
    return '<span class="lm-rating__row ' + cls + '">' + out + '</span>';
  }
  function ratingHtml() {
    var v = parseFloat(cfg.cartRating);
    if (!(v > 0 && v <= 5)) return '';
    var pct = Math.round((v / 5) * 1000) / 10;
    var txt = cfg.cartRatingText ? ' \u00b7 ' + cfg.cartRatingText : '';
    /* Zwei Darstellungen, eine im Markup, die Breite entscheidet per CSS.
       Gemessen im offenen Ausklapper: fuenf Sterne belegen 75 px. Zusammen mit
       "Likeness guaranteed" (146) und dem Text (144) sind das 384 px - auf einem
       440 px breiten Desktop-Ausklapper passt das, auf einem 390-px-Telefon mit
       358 px nutzbarer Breite nicht. Dort tritt ein einzelnes Sternsymbol an die
       Stelle der Reihe: 13 statt 75 px, und die Zeile landet bei 318 px. Nebenbei
       sieht sie dort aus wie die drei anderen Zusagen, die auch je ein Symbol
       tragen. */
    return '<span class="lm-cart-trust__rating" aria-label="' + escHtml(v + ' out of 5' + txt) + '">'
      + '<span class="lm-rating__track" style="--lm-rating-fill:' + pct + '%" aria-hidden="true">'
      + starRow('lm-rating__row--bg') + starRow('lm-rating__row--fg')
      + '</span>'
      + '<svg class="lm-cart-trust__star1" width="13" height="13" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false"><path d="' + STAR_PATH + '"/></svg>'
      + '<span aria-hidden="true">' + escHtml(cfg.cartRating + txt) + '</span></span>';
  }

  /* Trust-Zeile unter dem Checkout-Button (Drawer + Cart-Seite) */
  function renderTrust(container) {
    if (!cfg.cartTrust || !container || container.querySelector('.lm-cart-trust')) return;
    var btn = container.querySelector('#CartDrawer-Checkout, #checkout, .cart__checkout-button');
    if (!btn) return;
    var p = document.createElement('p');
    p.className = 'lm-cart-trust';
    /* Runde 27f: die Bewertung steht direkt HINTER der ersten Zusage, nicht am Ende.
       Bei vier Punkten und umbrechendem Flex landet sonst Zeile 1 mit einem Punkt und
       Zeile 2 mit dreien - Dima: "sonst ist wieder Platz verschwendung". splice(1,0,...)
       setzt sie an Position zwei, damit Zeile 1 aus Garantie + Bewertung besteht. */
    var parts = cfg.cartTrust.split('·').map(function (t) {
      return '<span>' + svgFor(t) + escHtml(t.trim()) + '</span>';
    });
    var rating = ratingHtml();
    if (rating) parts.splice(1, 0, rating);
    p.innerHTML = parts.join('');
    btn.insertAdjacentElement('afterend', p);
  }

  /* ---------- Liefertermin im Warenkorb (Runde 24) ----------
     Auf der Produktseite steht "In your hands Sep 20-22", im Warenkorb stand nichts. Genau
     dort - einen Klick vor dem Bezahlen - ist die Frage "wann ist es da" am lautesten, und
     ein konkretes Datum beantwortet sie deutlich besser als eine Spanne in Tagen: die
     Baymard-Untersuchungen zum Warenkorbabbruch fuehren unklare Lieferzeit regelmaessig unter
     den drei haeufigsten Gruenden. Dieselbe Rechnung wie im Konfigurator (ETA_MIN/ETA_MAX dort),
     damit nicht zwei Seiten zwei Termine nennen - das waere schlimmer als gar keiner. */
  var ETA_MIN = 5, ETA_MAX = 7;
  var ETA_MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* Runde 28: der Warenkorb nennt die LANGSAMSTE Zeile. Jede Zeile traegt _lead_min/_lead_max
     (vom Konfigurator bzw. vom Cross-Sell gesetzt); ohne Angabe gilt 5-7. Ein Puzzle neben
     einem Canvas heisst also: der ganze Korb zeigt die Puzzle-Frist. Zwei getrennte Termine
     waeren fuer den Kunden verwirrender als ein spaeter. */
  var lastCartLead = { min: ETA_MIN, max: ETA_MAX };
  function cartLead(cart) {
    var mn = ETA_MIN, mx = ETA_MAX;
    ((cart && cart.items) || []).forEach(function (it) {
      var p = it.properties || {};
      var a = parseInt(p._lead_min, 10), b = parseInt(p._lead_max, 10);
      if (b > mx) { mx = b; mn = a > 0 ? a : mn; }
    });
    return { min: mn, max: mx };
  }
  // Lieferzeit je Produktform fuer Cross-Sell-Zeilen (Kalendertage, wie im Konfigurator gerechnet).
  var FORM_LEAD = { puzzle: [17, 21] };
  function etaText() {
    var now = new Date();
    var a = new Date(now.getTime()); a.setDate(a.getDate() + lastCartLead.min);
    var b = new Date(now.getTime()); b.setDate(b.getDate() + lastCartLead.max);
    return a.getMonth() === b.getMonth()
      ? 'In your hands ' + ETA_MON[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate()
      : 'In your hands ' + ETA_MON[a.getMonth()] + ' ' + a.getDate() + ' – ' + ETA_MON[b.getMonth()] + ' ' + b.getDate();
  }

  function renderEta(container, cart) {
    if (!container) return;
    if (cart) lastCartLead = cartLead(cart);
    var btn = container.querySelector('#CartDrawer-Checkout, #checkout, .cart__checkout-button');
    if (!btn) return;
    var host = btn.closest('.cart__ctas') || btn.parentElement;
    if (!host) return;
    var line = host.parentElement.querySelector('.lm-cart-eta');
    if (!line) {
      line = document.createElement('p');
      line.className = 'lm-cart-eta';
      host.insertAdjacentElement('beforebegin', line);
    }
    line.innerHTML = '<span class="lm-cart-eta__ico" aria-hidden="true">' + svgFor('truck') + '</span>' +
                     '<span>' + etaText() + '</span>';
    line.setAttribute('title', 'Most orders arrive ' + lastCartLead.min + ' to ' + lastCartLead.max + ' days after you order.');
  }

  /* ---------- Cross-Sell aus derselben Preview (Runde 24) ----------
     Der staerkste AOV-Hebel des Modells: das Zusatzprodukt verlangt keine neue Entscheidung, sondern
     wiederholt die getroffene ("same portrait, no new upload"). Regel: erste Portrait-Zeile im Warenkorb
     liefert die Upload-/Preview-Properties; angeboten wird das erste Produkt aus data-xsell, das noch
     nicht im Warenkorb liegt. Varianten werden ueber /products/<handle>.js gelesen (kein Hardcoding).
     Properties mit "_" werden kopiert (Upload-IDs, Preview, Spezies), _form folgt dem Zielprodukt,
     _addons wird geleert; sichtbare Felder (Style, Design, Pet, Pet's name) bleiben. */
  var XSELL_FORM = { 'custom-pet-portrait-mug': 'mug', 'custom-pet-portrait-ornament': 'ornament', 'custom-pet-portrait-pillow': 'pillow', 'custom-pet-portrait-poster': 'poster', 'custom-pet-portrait-sherpa-blanket': 'blanket', 'custom-pet-portrait-t-shirt': 'tee', 'custom-pet-portrait-hoodie': 'hoodie',
    /* 16.09.: drei neue Warengruppen. _form steuert im Server die Druckgeometrie, muss also zu cropRuleFor() passen. */
    'custom-pet-portrait-phone-case': 'phone', 'custom-pet-portrait-tote-bag': 'tote', 'custom-pet-portrait-puzzle': 'puzzle' };
  var XSELL_NOUN = { mug: 'mug', ornament: 'ornament', pillow: 'pillow', poster: 'poster', blanket: 'blanket', tee: 't-shirt', hoodie: 'hoodie', phone: 'phone case', tote: 'tote bag', puzzle: 'puzzle' };
  var VISIBLE_ROWS = 2;   /* sofort sichtbar; der Rest liegt hinter "Show more" */
  var xsellCache = {};
  function productJson(handle) {
    if (xsellCache[handle]) return xsellCache[handle];
    xsellCache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return xsellCache[handle];
  }
  function moneyFull(cents) { return '$' + (cents / 100).toFixed(2); }
  /* Bis zu drei Vorschlaege statt einem.
     Grund: ein einzelner Vorschlag trifft nur den, der genau dieses Produkt wollte. Drei decken
     drei Preislagen ab (Ornament ~20, Tasse ~25, Kissen ~35) und lassen den Kunden waehlen statt
     ja/nein sagen. Das ist der Unterschied zwischen "willst du eine Tasse?" und "welche davon?".
     Zusaetzlich: wenn ein Vorschlag den Gratisversand ausloest, steht das dran - das ist der
     staerkste Grund, noch etwas dazuzulegen, und er ist wahr statt erfunden. */
  /* Frueher 3. Der Warenkorb ist die Stelle mit der hoechsten Kaufbereitschaft der ganzen Sitzung:
     das Portrait ist fertig, der Kunde hat es gesehen, und jedes weitere Produkt braucht KEINEN
     zweiten Upload. Drei Zeilen haben einen Teil des Sortiments einfach nie gezeigt. Jetzt sechs -
     aber in einem Kasten mit fester Hoehe, der scrollt. So sieht der Kunde mehr, ohne dass der
     Checkout-Knopf nach unten wandert; ein weggeschobener Checkout kostet mehr, als ein vierter
     Vorschlag einbringt. */
  var XSELL_MAX = 6;

  /* Eine Karte statt einer Zeile.
     Drei Gruende, alle auf dem Geraet gesehen:
     1. Sechs gestapelte Zeilen im Schubfach haben die Artikelliste vollstaendig verdraengt -
        der Kunde sah seinen eigenen Warenkorb nicht mehr, nur noch Vorschlaege.
     2. Jede Zeile zeigte dasselbe Portrait. Ornament, Becher und Poster sahen damit identisch
        aus; unterscheidbar waren sie nur am Wort. Wer nicht liest, sieht dreimal dasselbe.
        Jetzt fuehrt das Produktbild - das Portrait ist ohnehin im Titel versprochen.
     3. Quer scrollen kostet keine Hoehe. Der Checkout-Knopf bleibt, wo er hingehoert. */
  /* Runde 30 - Rabatt nur versprechen, wenn der Checkout ihn einloest.
     Der Shopify-Rabatt ist ein "Buy X get Y": je Portrait (Canvas) im Warenkorb bekommt GENAU
     EIN Extra 20 %, und zwar das guenstigste. Ein Basis-Rabatt "20 % auf alle Extras" liesse
     sich nicht an ein Portrait binden (die Mindestsumme zaehlt nur die Extras selbst), und
     mehrere Extras je Portrait kann Shopify nativ nicht. Deshalb: freie Plaetze = Portraits
     minus Extras; nur solange ein Platz frei ist, zeigt die Zeile den reduzierten Preis.
     Gemessen am 16.09.: Schubfach zeigte 18,71 $, Checkout kassierte 24,95 $ - genau der
     Abbruchgrund, den die Einstellung im Theme-Editor ausdruecklich warnt. */
  function xsellSlots(cart) {
    var portraits = 0, extras = 0;
    cart.items.forEach(function (it) {
      var pr = it.properties || {};
      if (pr._addon_key) return;
      if (pr._form === 'canvas') portraits += it.quantity;
      else if (pr._preview_job_id || pr._form) extras += it.quantity;
    });
    return Math.max(0, portraits - extras);
  }

  function xsellCard(src, p, handle, cartTotal, slots) {
    var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    for (var k = 0; k < p.variants.length; k++) {
      var o = p.variants[k];
      if (o.available && (o.options.indexOf('1') >= 0 || p.variants.length === 1)) { v = o; break; }
    }
    var form = XSELL_FORM[handle] || 'print';
    var noun = XSELL_NOUN[form] || 'print';
    var name = (src.properties && src.properties["Pet's name"]) || 'your pet';
    var shot = p.featured_image || (p.images && p.images[0]) || '';
    if (shot && shot.indexOf('//') === 0) shot = 'https:' + shot;
    if (shot) shot = shot.split('?')[0] + '?width=320';

    var unlocks = cfg.threshold > 0 && cartTotal < cfg.threshold && (cartTotal + v.price) >= cfg.threshold;

    /* Runde 25 - Zeile statt Kachel.
       Gemessen im Schubfach bei 723 px Hoehe: eine Kachel war 229 px hoch, sechs davon plus
       Ueberschrift ergaben 282 px, und der ganze Kasten lag 285 px unter der Sichtkante. Ein
       Angebot, das man erst durch Scrollen findet, ist kein Angebot. Die starken Upsell-Apps
       (Rebuy, ReConvert, Zipify) arbeiten deshalb mit Zeilen: Bild links, Name und Preis in der
       Mitte, Knopf rechts - rund 72 px statt 229. Zwei Zeilen stehen sofort im Bild, der Rest
       liegt hinter "Show more", weil mehr als zwei sichtbare Angebote die Entscheidung
       verschlechtern statt sie zu erleichtern. */
    var pct = slots > 0 ? cfg.xsellDiscount : 0;
    var now = pct > 0 ? Math.round(v.price * (100 - pct) / 100) : v.price;

    var el = document.createElement('article');
    el.className = 'lm-xrow'; el.dataset.handle = handle;
    el.innerHTML =
      '<span class="lm-xrow__media">' +
        (shot ? '<img src="' + shot + '" alt="" width="120" height="120" loading="lazy">' : '') +
      '</span>' +
      '<span class="lm-xrow__body">' +
        '<span class="lm-xrow__name">' + String(name).replace(/</g, '&lt;') + "'s " + noun + '</span>' +
        '<span class="lm-xrow__prices">' +
          (pct > 0 ? '<s class="lm-xrow__was">' + moneyFull(v.price) + '</s>' : '') +
          '<span class="lm-xrow__now">' + moneyFull(now) + '</span>' +
          (pct > 0 ? '<span class="lm-xrow__save">\u2212' + pct + '%</span>' : '') +
          (unlocks ? '<span class="lm-xrow__flag">Free shipping</span>' : '') +
        '</span>' +
      '</span>' +
      '<button type="button" class="lm-xcard__btn lm-xrow__btn">Add</button>';

    var btn = el.querySelector('.lm-xcard__btn');
    btn.addEventListener('click', function () {
      btn.disabled = true; btn.textContent = 'Adding…';
      var props = {};
      Object.keys(src.properties || {}).forEach(function (key) {
        if (key.charAt(0) === '_' || key === 'Style' || key === 'Design' || key === 'Pet' || key === "Pet's name") props[key] = src.properties[key];
      });
      props._form = form; props._addons = ''; props._xsell_from = String(src.key || '');
      var lead = FORM_LEAD[form]; if (lead) { props._lead_min = String(lead[0]); props._lead_max = String(lead[1]); } else { delete props._lead_min; delete props._lead_max; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }], sections: 'cart-drawer,cart-icon-bubble' }) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { btn.disabled = false; btn.textContent = 'Add'; return; }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
          if (window.dataLayer) window.dataLayer.push({ event: 'CrossSellAdded', handle: handle, value: v.price / 100 });
          document.dispatchEvent(new CustomEvent('lm:cart-updated'));
          refresh();
        })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
    });
    return el;
  }

  function renderXsell(container, cart) {
    if (!cfg.xsell.length || !container) return;
    /* Der Kasten gehoert NICHT in die Fusszeile. Dort waechst er in denselben Bereich, in dem
       Summe und Checkout stehen, und drueckt im Schubfach die Artikelliste auf null Hoehe -
       genau das war auf dem iPhone zu sehen. Er gehoert ans Ende der Artikelliste selbst,
       in den Bereich, der ohnehin scrollt. */
    function findHost() {
      return container.querySelector('cart-drawer-items .cart__contents')
          || container.querySelector('.cart__items')
          || container.querySelector('cart-items')
          || container.querySelector('.drawer__footer, .cart__footer');
    }
    if (!findHost()) return;

    var old = container.querySelector('.lm-xsell-box');
    var src = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.properties && it.properties._preview_job_id) { src = it; break; }
    }
    if (!src) { if (old) old.remove(); return; }

    var inCart = cart.items.map(function (it) { return it.handle; });
    var want = cfg.xsell.filter(function (h) { return inCart.indexOf(h) < 0; }).slice(0, XSELL_MAX);
    if (!want.length) { if (old) old.remove(); return; }
    var slots = xsellSlots(cart);
    var keys = want.join(',') + '|' + slots;
    if (old && old.dataset.keys === keys) return;   // nichts hat sich geaendert
    /* Race-Schutz: refresh() laeuft beim Oeffnen des Drawers zweimal kurz nacheinander
       (Dawn rendert neu -> MutationObserver -> refresh). Beide Laeufe sahen "kein Kasten da",
       beide luden die Produkte asynchron, beide haengten einen an - der Kasten stand doppelt.
       Pro Container laeuft jetzt nur ein Aufbau je Schluessel; nach dem async-Loch wird
       host neu gesucht und JEDER vorhandene Kasten entfernt, bevor genau einer angehaengt wird. */
    if (container.__lmXsellBusy === keys) return;
    container.__lmXsellBusy = keys;

    Promise.all(want.map(productJson)).then(function (list) {
      if (container.__lmXsellBusy === keys) container.__lmXsellBusy = null;
      var host = findHost();
      if (!host) return;
      var box = document.createElement('div');
      box.className = 'lm-xsell-box';
      box.dataset.keys = keys;
      var head = document.createElement('p');
      head.className = 'lm-xsell-box__head';
      head.textContent = 'Same portrait, no second upload';
      box.appendChild(head);
      /* Runde 25: Der Hinweis auf die Ersparnis gehoert in die Ueberschrift, nicht an jede
         Zeile - dort wiederholt er sich sechsmal und wird zu Tapete. */
      if (cfg.xsellDiscount > 0 && cfg.xsellDiscountNote) {
        var hint = document.createElement('span');
        hint.className = 'lm-xsell-box__hint';
        /* Platz frei: Zusage. Kein Platz mehr: sagen, warum der Preis jetzt voll ist. */
        hint.textContent = slots > 0 ? cfg.xsellDiscountNote : (cfg.xsellDiscountUsed || 'Your 20% extra is in the cart');
        if (slots <= 0) hint.classList.add('lm-xsell-box__hint--used');
        head.appendChild(hint);
      }
      var rows = document.createElement('div');
      rows.className = 'lm-xsell-rows';
      box.appendChild(rows);
      var n = 0;
      list.forEach(function (p, idx) {
        if (!p || !p.variants || !p.variants.length) return;
        var row = xsellCard(src, p, want[idx], cart.total_price || 0, slots);
        if (n >= VISIBLE_ROWS) row.hidden = true;
        rows.appendChild(row);
        n++;
      });
      if (!n) { container.querySelectorAll('.lm-xsell-box').forEach(function (b) { b.remove(); }); return; }

      /* Mehr-Knopf nur, wenn es wirklich mehr gibt. Er klappt auf und verschwindet - ein
         Zuklappen braucht niemand, wer einmal mehr sehen wollte, will es weiter sehen. */
      if (n > VISIBLE_ROWS) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'lm-xsell-box__more';
        more.textContent = 'Show ' + (n - VISIBLE_ROWS) + ' more';
        more.addEventListener('click', function () {
          rows.querySelectorAll('.lm-xrow[hidden]').forEach(function (r) { r.hidden = false; });
          more.remove();
        });
        box.appendChild(more);
      }
      container.querySelectorAll('.lm-xsell-box').forEach(function (b) { b.remove(); });
      host.appendChild(box);
    }).catch(function () { if (container.__lmXsellBusy === keys) container.__lmXsellBusy = null; });
  }

  /* E-Mail-Capture-Dialog ("No photo handy?") */
  function capture() {
    var dlg = document.getElementById('lm-capture');
    if (!dlg) return;
    function open(detail) {
      var note = dlg.querySelector('[data-lm-capture-note]');
      if (note) note.value = 'upload-link requested on ' + location.pathname + (detail && detail.template_id ? ' · template ' + detail.template_id : '');
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      var inp = dlg.querySelector('input[type=email]'); if (inp) setTimeout(function () { inp.focus(); }, 50);
    }
    document.addEventListener('lm:open-email-capture', function (e) { open(e.detail); });
    var close = dlg.querySelector('[data-lm-capture-close]');
    if (close) close.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    /* Nach dem Formular-Post kommt die Seite mit ?customer_posted=true zurück → Erfolgsansicht zeigen */
    if (location.search.indexOf('customer_posted=true') > -1 && dlg.querySelector('.lm-capture__form') && !dlg.querySelector('input[type=email]')) open();
  }

  /* Runde 24, gemessen bei 1512 px: die Vorschau war 1920 px breit und stand in einer
     110-px-Zelle - und zwar auf JEDER Seite, denn Dawn haelt den Cart-Drawer immer im DOM
     und refresh() laeuft beim Laden einmal durch. Zwei Bilder zu je rund zwei Megabyte,
     geladen bevor der Besucher irgendetwas angeklickt hat. Jetzt wird die Adresse nur
     gemerkt; gesetzt wird sie erst, wenn der Warenkorb wirklich sichtbar ist. Bis dahin
     bleibt Dawns eigenes, korrekt skaliertes Produktbild stehen - der Besucher sieht also
     nicht weniger, er laedt nur nicht mehr, als er gerade sieht. */
  function cartVisible() {
    var d = document.querySelector('cart-drawer');
    if (d && d.classList.contains('active')) return true;
    return !!document.querySelector('cart-items');   /* eigenstaendige Warenkorbseite */
  }

  function hydratePreviews() {
    document.querySelectorAll('img[data-lm-preview-src]').forEach(function (img) {
      var u = img.getAttribute('data-lm-preview-src');
      if (!u || img.dataset.lmPreview === u) return;
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.src = u; img.dataset.lmPreview = u;
    });
  }

  /* Add-on-Zeilen (eigene Warenkorbzeilen mit _addon_key) kompakt zeichnen: kein Mengen-Stepper
     (eine Datei bzw. Bearbeitung pro Portrait, Menge 2 ergibt keinen Sinn), Loeschen bleibt. */
  function markAddonRows(cart) {
    cart.items.forEach(function (item, i) {
      var isAddon = !!(item.properties && item.properties._addon_key);
      ['#CartDrawer-Item-' + (i + 1), '#CartItem-' + (i + 1)].forEach(function (sel) {
        var row = document.querySelector(sel);
        if (row) row.classList.toggle('lm-cart-item--addon', isAddon);
      });
    });
  }

  function swapPreviews(cart) {
    if (!cfg.previews) return;
    markAddonRows(cart);
    cart.items.forEach(function (item, i) {
      /* Runde 24: bevorzugt die 360-px-Miniatur. Der Warenkorb zeigte bisher die volle
         Vorschau in einer 93-px-Zelle - bei Altbestellungen sogar den Druckmaster mit
         1920 px und rund sieben Megabyte. */
      var url = item.properties && (item.properties._preview_thumb || item.properties._preview_url);
      if (!url) return;
      ['#CartDrawer-Item-' + (i + 1), '#CartItem-' + (i + 1)].forEach(function (sel) {
        var row = document.querySelector(sel);
        if (!row) return;
        var img = row.querySelector('.cart-item__image');
        if (!img) { /* Produkt ohne Bild (Dawn rendert dann kein <img>): eigenes anlegen */
          var cell = row.querySelector('.cart-item__media');
          if (!cell) return;
          img = document.createElement('img');
          img.className = 'cart-item__image';
          img.width = 150; img.height = 150; img.loading = 'lazy';
          cell.appendChild(img);
        }
        if (img.dataset.lmPreview === url) return;
        img.dataset.lmPreviewSrc = url; img.classList.add('lm-cart-preview');
        img.alt = (item.product_title || '') + ' \u2014 your preview';
        if (cartVisible()) hydratePreviews();
      });
    });
  }

  /* ---------- 4) Reveal beim Scrollen ----------
     Nur unterhalb des ersten Bildschirms und nie im Hero: was der Kunde sofort sieht, darf nicht erst erscheinen (LCP).
     Die Klasse kommt aus JS — ohne JS oder ohne IntersectionObserver ist nichts versteckt. */
  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* Drei Eintraege der alten Liste (.lm-ugc__card, .lm-compare, .lm-teaser__inner) trafen kein Element im
       Theme - die Vergleichstabelle, die Galerie und der Teaser blieben als einzige Abschnitte ohne
       Einblendung stehen. Selektoren, die nichts treffen, fallen nicht auf: sie sehen aus wie "keine
       Animation gewollt". Deshalb hier nur Klassen, die es wirklich gibt. */
    var sel = '.lm-section__head, .lm-grid > *, .lm-hiw__step, .lm-why__item, .lm-cats__item, .lm-faq__item, .lm-ugc__tile, .lm-cmp__row, .lm-cta__inner, .lm-teaser__pet, .lm-seo__copy, .lm-seo__media';
    var vh = window.innerHeight || 800;
    var items = [];
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.closest('.lm-hero')) return;
      if (el.classList.contains('lm-reveal')) return;
      /* Nicht gerenderte Elemente (inaktiver Tab, [hidden]) auslassen: sie loesen nie ein
         Intersection-Event aus und blieben sonst fuer immer unsichtbar. */
      if (!el.offsetParent) return;
      if (el.getBoundingClientRect().top < vh * 0.9) return;
      el.classList.add('lm-reveal');
      items.push(el);
    });
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var i = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--lm-reveal-delay', Math.min(i, 5) * 55 + 'ms');
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Der Zähler quittiert das Hinzufügen — sonst merkt der Kunde auf dem Handy nicht, dass etwas passiert ist. */
  var lastCount = null;
  function bumpCart(count) {
    if (lastCount !== null && count > lastCount) {
      document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
        b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
      });
    }
    lastCount = count;
  }

  var pending = null;
  /* Dawn schreibt hinter jede Option ausser der letzten ein Komma ("Size: 11 oz,") und zeigt die
     Variantenachse "Pets: 1" - fuer den Kunden Rauschen. Komma weg, "Pets: 1" ausblenden (2 und 3 bleiben:
     dann steht die Zahl fuer etwas). Nur Text und eine Klasse, keine Struktur, damit Dawns eigene
     Updates weiter funktionieren. */
  function tidyOptions() {
    document.querySelectorAll('.cart-item .product-option').forEach(function (row) {
      var dd = row.querySelector('dd'), dt = row.querySelector('dt');
      if (dd && /,\s*$/.test(dd.textContent)) dd.textContent = dd.textContent.replace(/,\s*$/, '').trim();
      if (dt && dd && /^Pets:?\s*$/i.test(dt.textContent.trim()) && dd.textContent.trim() === '1') row.hidden = true;
    });
  }

  /* Runde 26: verwaiste Add-on-Zeilen aufraeumen.
     Add-ons sind seit heute eigene Warenkorbzeilen mit '_parent' = preview_job_id des Portraits.
     Loescht der Kunde das Portrait, bliebe das Add-on allein im Warenkorb stehen - er zahlte 5 $
     fuer eine Datei zu einem Bild, das er nicht bestellt. Diese Funktion entfernt solche Zeilen
     still, bevor der Warenkorb gezeichnet wird. Sie laeuft genau einmal pro Aufraeumvorgang
     (guard), damit das MutationObserver-Update sie nicht in eine Schleife zieht. */
  var tidying = false;
  function dropOrphanAddons(cart) {
    if (tidying || !cart || !cart.items) return false;
    var parents = {};
    cart.items.forEach(function (it) {
      var pr = it.properties || {};
      if (!pr._addon_key && pr._preview_job_id) parents[pr._preview_job_id] = true;
    });
    var orphans = cart.items.filter(function (it) {
      var pr = it.properties || {};
      return pr._addon_key && (!pr._parent || !parents[pr._parent]);
    });
    if (!orphans.length) return false;
    tidying = true;
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    var chain = Promise.resolve();
    orphans.forEach(function (it) {
      chain = chain.then(function () {
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: 0 })
        });
      });
    });
    chain.then(function () {
      tidying = false;
      document.dispatchEvent(new CustomEvent('lm:cart-updated'));
    }).catch(function () { tidying = false; });
    return true;
  }

  function refresh() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (dropOrphanAddons(cart)) return;
          var drawer = document.querySelector('cart-drawer .drawer__inner');
          var page = document.querySelector('cart-items');
          renderShipbar(drawer, cart);
          /* Dawn haelt den Cart-Drawer auf JEDER Seite im DOM. Die alte Bedingung (!drawer) hat den
             Balken deshalb auf der Warenkorbseite nie gezeichnet — er lag unsichtbar im Drawer. */
          if (page) renderShipbar(page.closest('.cart__contents') || page.parentElement, cart);
          renderTrust(document.querySelector('cart-drawer') || document);
          renderEta(document.querySelector('cart-drawer') || document, cart);
          if (page) renderTrust(document.querySelector('.cart__footer') || document);
          if (page) renderEta(document.querySelector('.cart__footer') || document, cart);
          renderXsell(document.querySelector('cart-drawer'), cart);
          if (page) renderXsell(page.closest('#MainContent') || document, cart);
          swapPreviews(cart);
          tidyOptions();
          bumpCart(cart.item_count);
          paintHeaderIcons(); /* Dawn rendert das Warenkorb-Icon nach jedem Update neu */
        })
        .catch(function () {});
    }, 120);
  }

  function watchCart() {
    var targets = ['cart-drawer', 'cart-items', 'cart-drawer-items'].map(function (t) { return document.querySelector(t); }).filter(Boolean);
    if (!targets.length) return;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.target.nodeType === 1 && m.target.closest && m.target.closest('.lm-shipbar, .lm-xsell')) continue; /* eigene Änderungen ignorieren (sonst Endlosschleife) */
        if (m.type === 'childList' && m.addedNodes.length) { refresh(); return; }
        if (m.type === 'attributes' && m.attributeName === 'class' && m.target.tagName === 'CART-DRAWER' && m.target.classList.contains('active')) { hydratePreviews(); refresh(); return; }
      }
    });
    targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); });
    document.addEventListener('cart:refresh', refresh);
    refresh();
  }

  /* Collection: hide the sort control when there is only one product */
  function tidyFacets() {
    var c = document.querySelector('.product-count__text, #ProductCountDesktop');
    if (!c) return;
    var n = parseInt((c.textContent || '').trim(), 10);
    if (n !== 1) return;
    document.querySelectorAll('.facets-vertical-sort, .mobile-facets__wrapper').forEach(function (f) { f.style.display = 'none'; });
  }

  /* Fusszeile auf dem Handy zusammenklappen.
     Gemessen: 1738 px - drei Linklisten und ein Textblock, alle offen untereinander. Das ist
     laenger als jeder Abschnitt der Startseite und steht am Ende einer Seite, die ohnehin
     14.000 px hat. Niemand liest dort 17 Links; gesucht wird hoechstens einer, meist
     "Versand" oder "Kontakt". Zusammengeklappt sind es rund 500 px, und der gesuchte Link
     ist einen Fingertipp entfernt statt sechs Wischer.
     Am Desktop bleibt alles offen - dort steht die Fusszeile nebeneinander und kostet nichts.
     Umgesetzt ueber das open-Attribut statt ueber CSS, weil Browser den Inhalt eines
     geschlossenen <details> selbst ausblenden und sich das nicht zuverlaessig ueberschreiben laesst. */
  function footerAccordion() {
    var blocks = [].slice.call(document.querySelectorAll('.footer-block--menu'));
    if (!blocks.length) return;
    var dets = [];
    blocks.forEach(function (b) {
      if (b.dataset.lmAcc) { var ex = b.querySelector('.lm-facc'); if (ex) dets.push(ex); return; }
      var head = b.querySelector('.footer-block__heading');
      var list = b.querySelector('ul');
      if (!head || !list) return;
      b.dataset.lmAcc = '1';
      var det = document.createElement('details');
      det.className = 'lm-facc';
      var sum = document.createElement('summary');
      sum.className = 'lm-facc__sum';
      sum.textContent = head.textContent.trim();
      det.appendChild(sum);
      det.appendChild(list);
      b.appendChild(det);
      dets.push(det);
    });
    if (!dets.length) return;
    var mq = window.matchMedia('(max-width: 749px)');
    function apply() {
      var mobile = mq.matches;
      document.body.classList.toggle('lm-footer-acc', mobile);
      dets.forEach(function (d) {
        if (mobile) d.removeAttribute('open'); else d.setAttribute('open', '');
      });
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  function init() { paintHeaderIcons(); iconLabels(); megaMenu(); backToTop(); stickyCta(); watchCart(); capture(); reveal(); tidyFacets(); footerAccordion(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { paintHeaderIcons(); iconLabels(); megaMenu(); refresh(); reveal(); });
})();